<template>
  <div class="salary">
    <h3>薪资结构</h3>
    <span>公司为员工提供全面的、富有竞争力的薪资鼓励待遇。</span>
    <div class="icons">
      <el-card
        v-for="(item, index) in salaryIcons"
        :key="index"
        style="
          width: 376px;
          height: 297px;
          text-align: center;
          justify-content: center;
        "
        :style="{
          marginLeft: index == 0 ? '0px' : '20px',
          backgroundColor: item.backgroundColor,
        }"
        shadow="never"
        :body-style="{ padding: '0px' }"
      >
        <div>
          <img
            :src="item.icon"
            alt
            style="
              width: 109px;
              height: 109px;
              margin-top: 73px;
              margin-bottom: 52px;
            "
          />
          <span
            style="
              color: #1A1A1A;
              font-size: 1.125rem;
              line-height: 1.75rem;
              font-weight: 600;
              text-align: center;
              display: block;
            "
            >{{ item.title }}</span
          >
        </div>
      </el-card>
    </div>
  </div>
</template>

<style scoped>
h3 {
  font-size: 24px;
  color: #1A1A1A;
  line-height: 36px;
  padding-top: 50px;
  padding-bottom: 38px;
}

.el-card{
  border-radius: 0px
}
span{
  line-height:1.375rem;
  font-size:.875rem;
  color:#777777;
}
.icons {
  position: relative;
  display: flex;
  flex-flow: row;
  flex-wrap: nowrap;
  justify-content: center;
  text-align: center;
  place-content: 80px;
  margin-top: 49px;
  margin-bottom: 50px;
}
</style>
<script>
export default {
  data() {
    return {
      msg: "薪资结构",
      salaryIcons: [
        {
          icon: require("../assets/welfare/ic_monthly_salary.png"),
          title: "月度工资",
          backgroundColor: "#F5E1E0",
        },
        {
          icon: require("../assets/welfare/ic_double_pay.png"),
          title: "年底双薪",
          backgroundColor: "#E1F1F3",
        },
        {
          icon: require("../assets/welfare/ic_annual_bonus.png"),
          title: "年度奖金",
          backgroundColor: "#ECF3DC",
        },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Salary.vue